'use strict';

const _=require('pulsar-utils/dist-es6/_');
const timespan=require('pulsar-utils/dist-es6/time/timespan');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const pulsarDate=require('pulsar-utils/dist-es6/pulsarDate');
const FatigueMeterType=require('pulsar-utils/dist-es6/domain/fatigueMeterType');
const GroupBasedDataService=require('../../../dist-es6/client/services/groupBasedDataService');let

FleetIncidentsDataService=class FleetIncidentsDataService extends GroupBasedDataService{
static get $inject(){
return['$timeout','statisticalDisplayDataService','timeZoneService','groupTreeService'];
}

constructor($timeout,statisticalDisplayDataService,timeZoneService,groupTreeService){
super($timeout,groupTreeService);
this._statisticalDisplayDataService=statisticalDisplayDataService;
this._timeZoneService=timeZoneService;
this._redirectResolved=!1;

this._clearPersistentData();
}

get localTimeZone(){
return this._timeZoneService.localTimeZone;
}

get displayInterval(){
return this._displayInterval;
}

set displayInterval(displayInterval){
this._displayInterval=displayInterval;
}

get incidentTypes(){
return this._incidentTypes;
}

_clearPersistentData(){
super._clearPersistentData();
this._displayInterval=void 0;
this._incidentTypes=void 0;
}

get redirectResolved(){
return this._redirectResolved;
}

set redirectResolved(redirectResolved){
this._redirectResolved=redirectResolved;
}

async _update(cancellationToken){


const queryInterval=_expandLocalIntervalToContainAllTimeZonesOfSameDay(this._displayInterval,this.localTimeZone);
const{groupTree,incidentTypes,hideAllGroupsByDefault}=await this._statisticalDisplayDataService.fetchFleetIncidentsDataFor({queryInterval});

if(cancellationToken.cancelled){
return;
}

this._groupTreeService.updateOrgLevelGroupVisibilitySettings({
hideAllGroupsByDefault:hideAllGroupsByDefault});


this.groupTree=groupTree;
this._incidentTypes=incidentTypes;
}};


const maxTimezoneOffsetBeforeUTC=timespan.fromHours(14);
const maxTimezoneOffsetAfterUTC=timespan.fromHours(12);

function _expandLocalIntervalToContainAllTimeZonesOfSameDay(displayInterval,localTimeZone){
const intervalInLocalTime=displayInterval.expandToRoundTarget('day',localTimeZone);
const localQueryIntervalShiftedToUTC=intervalInLocalTime.shiftedToTimeZone(localTimeZone,'utc');

const allTimezoneIntervalStartTime=pulsarDate(localQueryIntervalShiftedToUTC.start).minus(maxTimezoneOffsetBeforeUTC);
const allTimezoneIntervalEndTime=pulsarDate(localQueryIntervalShiftedToUTC.end).plus(maxTimezoneOffsetAfterUTC);

return TimeInterval.from(allTimezoneIntervalStartTime).to(allTimezoneIntervalEndTime);
}

module.exports=FleetIncidentsDataService;
module.exports.expandLocalIntervalToContainAllTimeZonesOfSameDay=_expandLocalIntervalToContainAllTimeZonesOfSameDay;
//# sourceMappingURL=fleetIncidentsDataService.js.map
